import { Stack } from "@mui/material"
import { TEmailReportInformation } from "./types"
import "./styles.scss"
import { Divider, EmptyContent, Header, Icon, LoadingContainer, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"

export function EmailReportInformation({ lastLog }: TEmailReportInformation) {
    const { t, i18n } = useTranslation()

    /*
        === TODO ===
        - Validate sender domain for checkmark
        - what is the second ish subject
        - where do the name come from, check with seb
    */

    return <Stack className="emailReportInformation">
        <LoadingContainer loading={!lastLog && lastLog !== null}>
            {lastLog && <>
                <Typography variant="displayS" marginBottom={2}>{lastLog.tags.join(", ")}</Typography>
                <Stack direction="row" gap={2} marginBottom={8}>
                    <Icon name="Tag18" />
                    <Typography variant="body1L">{t("general-x-tags", { count: lastLog.tags.length })}</Typography>
                    <Typography variant="linkL">{t("general-add-tag")}</Typography>
                </Stack>

                <Stack>
                    <Header
                        support={t("general-subject")}
                        heading={lastLog.subject}
                        headingVariant="h3S"
                        desc="Another subject ?"
                    />
                    <Divider />
                    <Header
                        support={t("general-from")}
                        heading={lastLog.sender_name}
                        headingVariant="h3S"
                        desc={lastLog.sender_email}
                    />
                </Stack>
            </>}
            {lastLog === null && <EmptyContent
                title={t("analytic-block-loading-error-title")}
            />}
        </LoadingContainer>
    </Stack>
}